/* eslint-disable react-hooks/exhaustive-deps */
import Description from "component/Common/Description";
import { formatPrice } from "helpers/common";
import { getRating } from "helpers/hotelHelper";
import useApiClient from "hooks/useApiClient";
import useToggle from "hooks/useToggle";
import React, { useEffect, useState } from "react";
import {
    Card,
    Nav,
    NavItem,
    NavLink,
    Offcanvas,
    OffcanvasBody,
    OffcanvasHeader,
    TabContainer,
    TabContent,
    TabPane,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BsArrowRight, BsStarFill } from "react-icons/bs";
import { FaLocationDot } from "react-icons/fa6";
import { GrNext } from "react-icons/gr";
import { Link } from "react-router-dom";
import CombinedRooms from "./CombinedRooms";
import NotCombinedRooms from "./NotCombinedRooms";
import { toast } from "react-toastify";
import useHotelSearchParams from "hooks/hotel/useHotelSearchParams";
import LazyImage from "component/Common/LazyImage";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
const IMAGE_PLACEHOLDER =
    "https://t3.ftcdn.net/jpg/06/86/19/34/240_F_686193407_DHZwjeydBOR1tEDkLAzwM3w5kYstRzzB.jpg";
const HotelCard = ({ hotel }) => {
    const { i18n, t } = useTranslation();
    const { isOpen, toggle } = useToggle();
    const rating = getRating(hotel?.stars);

    const imageList =
        hotel?.images && hotel?.images.length > 0
            ? hotel?.images
            : [
                  {
                      url: hotel?.image  || IMAGE_PLACEHOLDER,
                      id: -21,
                      hotel_code: hotel?.code,
                      title: null,
                      type: null,
                  },
              ];

    const sliderSettings = {
        dots: false,
        infinite: hotel?.images && hotel?.images.length > 1,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: (
            <button className="slider-btn next-btn">
                <GrNext
                    className={`w-4 h-4  ${
                        i18n.language === "ar" ? "rotate-180" : ""
                    }`}
                />
            </button>
        ),
        prevArrow: (
            <button className="slider-btn prev-btn">
                <GrNext
                    className={`w-4 h-4 ${
                        i18n.language === "ar" ? "" : "rotate-180"
                    }`}
                />
            </button>
        ),
    };

    if (typeof hotel?.address === "object") {
        hotel.address = "No address";
    }
    return (
        <>
            <div className={"col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12"}>
                <div className="theme_common_box_two img_hover">
                    <div className="theme_two_box_img h-[200px] relative group">
                        <Slider {...sliderSettings}>
                            {imageList.map((img, index) => (
                                <LazyImage src={img?.url} index={index} />
                            ))}
                        </Slider>
                    </div>
                    <div className="flex flex-col gap-2 p-2 min-h-[150px]">
                        <div className=" flex gap-1 items-center">
                            {[1, 2, 3, 4, 5].map((i) => (
                                <BsStarFill
                                    key={i}
                                    size={16}
                                    className={`${
                                        i <= rating
                                            ? "text-yellow-500"
                                            : "text-gray-300"
                                    }`}
                                />
                            ))}
                        </div>
                        <h4 className="whitespace-nowrap flex items-center overflow-hidden text-ellipsis">
                            <Link className="text-black truncate " to="">
                                {hotel?.name}
                            </Link>
                        </h4>
                        <div className=" -mt-1">
                            <div className="gap-1 whitespace-nowrap flex items-center overflow-hidden text-ellipsis ">
                                <FaLocationDot
                                    size={16}
                                    className="text-paragraph-color"
                                />
                                <span className="truncate text-sm text-paragraph-color  inline-block ">
                                    {hotel?.address}
                                </span>
                            </div>
                        </div>
                        <div className="flex justify-between items-center mt-6">
                            <h3 className="text-lg font-semibold">
                                {formatPrice(hotel?.minRate?.total)}
                            </h3>
                            <div
                                onClick={toggle}
                                className="flex gap-1 items-center justify-center px-3 py-1 font-semibold cursor-pointer bg-hover-color text-main-color w-fit border border-main-color  rounded-md duration-200 hover:bg-main-color hover:text-white "
                            >
                                {t("select")}
                                <BsArrowRight className=" ms-2" />
                            </div>
                        </div>
                    </div>
                </div>
                <Offcanvas
                    placement="end"
                    show={isOpen}
                    backdrop={true}
                    onHide={toggle}
                    className="drawer w-[90%] md:w-[80%] xl:w-[50%] h-screen"
                    tabIndex={-1}
                    id="offcanvasSidebar"
                    aria-labelledby="offcanvasSidebarLabel"
                >
                    <OffcanvasHeader
                        className="offcanvas-header p-3 border-b"
                        closeButton
                    >
                        <h5
                            className="offcanvas-title truncate-text"
                            id="offcanvasSidebarLabel"
                        >
                            {hotel?.name}
                        </h5>
                    </OffcanvasHeader>
                    <OffcanvasBody className="offcanvas-body flex-column ">
                        <HotelTabs hotel={hotel} />
                    </OffcanvasBody>
                </Offcanvas>
            </div>
        </>
    );
};

export default HotelCard;

const HotelTabs = ({ hotel }) => {
    const [isLoading, setIsLoading] = useState(hotel.callRoomAvailability);
    const { prepareAvailabilityPayload } = useHotelSearchParams();
    const [selectedHotel, setSelectedHotel] = useState(hotel);
    const { api, urls } = useApiClient();
    const { t , i18n  } = useTranslation();
    useEffect(() => {
        if (isLoading) {
            const payload = prepareAvailabilityPayload();
            payload["provider"] = hotel.provider;
            payload["provider_id"] = hotel.provider_id;
            payload["code"] = hotel.code;
            payload["hotelCodeCrypted"] = hotel?.hotelCodeCrypted;
            api.post(urls.hotel.availability + `?language=${i18n.language}`, JSON.stringify(payload))
                .then((res) => {
                    if (
                        !res.data ||
                        res.data?.error ||
                        res.data?.hasOwnProperty("IBE_Errors") ||
                        res.data?.result?.length === 0
                    ) {
                        toast.error(t("tryAgainLater"));
                        return null;
                    }
                    if (res?.data?.result) {
                        setSelectedHotel((prev) => {
                            return {
                                ...prev,
                                rates:
                                    res?.data?.result[hotel.code]?.rates || [],
                                rooms:
                                    res?.data?.result[hotel.code]?.rooms || {},
                                boards:
                                    res?.data?.result[hotel.code]?.boards || {},
                            };
                        });
                    } else {
                        console.log("error");
                        toast.error(t("tryAgainLater"));
                    }
                })
                .catch((err) => {
                    toast.error(t("tryAgainLater"));
                    console.log(err);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
        
    }, [isLoading]);

    return (
        <TabContainer defaultActiveKey="1">
            <Nav
                variant="tabs"
                role="tablist"
                justify
                className="border-none bg-hover-color rounded-md py-1  flex flex-nowrap px-2 mx-auto overflow-x-auto"
            >
                <NavItem role="presentation">
                    <NavLink
                        eventKey="1"
                        className="text-center bg-transparent cursor-pointer my-1 truncate"
                    >
                        {t("rooms")}
                    </NavLink>
                </NavItem>
                <NavItem role="presentation">
                    <NavLink
                        eventKey="2"
                        className="text-center bg-transparent cursor-pointer my-1 truncate "
                    >
                        {t("hotelDescription")}
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent className="mb-0">
                <TabPane eventKey="1" className="fade">
                    {selectedHotel.combinedRooms ? (
                        <CombinedRooms
                            hotel={selectedHotel}
                            isLoading={isLoading}
                        />
                    ) : (
                        <NotCombinedRooms
                            isLoading={isLoading}
                            hotel={selectedHotel}
                        />
                    )}
                </TabPane>
                <TabPane eventKey="2" className="fade">
                    <Card className="">
                        <Description
                            rawDescription={selectedHotel?.description || ""}
                        />
                    </Card>
                </TabPane>
            </TabContent>
        </TabContainer>
    );
};
